import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CheckOutlined = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="Normal / Check-Single" clipPath="url(#clip0_3001_4891)">
        <mask
          id="mask0_3001_4891"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect id="Bounding box" width="16" height="16" />
        </mask>
        <g mask="url(#mask0_3001_4891)">
          <path
            id="Check-Single"
            d="M6.37208 13.5002C6.08311 13.5002 5.80599 13.3948 5.60169 13.2072L2.33269 10.2072C2.04942 9.95616 1.93582 9.58435 2.03554 9.23472C2.13526 8.88509 2.43279 8.61205 2.81377 8.52053C3.19475 8.42902 3.59989 8.53327 3.87348 8.79323L6.20318 10.9312L12.0035 2.94523C12.3375 2.48573 13.0141 2.36171 13.5148 2.66823C14.0155 2.97475 14.1507 3.59573 13.8167 4.05523L7.27869 13.0552C7.099 13.3059 6.8062 13.4692 6.48105 13.5002C6.44291 13.5002 6.40804 13.5002 6.37208 13.5002Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3001_4891">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

CheckOutlined.displayName = 'CheckOutlined';
